import type { Card /* CardType */ } from "@apac/checkout";

// XXX don't know why but Cypress can't read this from @apac/checkout
export enum CardType {
  CreditCard = "Credit Card",
  DebitCard = "Debit Card",
  CreditCardUSD = "Credit Card USD",
}

export const testCardData: Card = {
  type: CardType.CreditCard,
  name: "Adyen Test Card",
  incentives: [
    {
      name: "cashback",
      type: "percent",
      value: 0.5,
    },
  ],
};

export const hsbcCardMap: Record<string, Card> = {
  543062: {
    type: CardType.CreditCard,
    name: "Privé",
    incentives: [
      {
        name: "cashback",
        type: "percent",
        value: 0.5,
      },
    ],
  },
  525532: {
    type: CardType.CreditCard,
    name: "TravelOne",
    incentives: [
      {
        name: "cashback",
        type: "percent",
        value: 0.5,
      },
    ],
  },
  436324: {
    type: CardType.CreditCard,
    name: "Advance",
    incentives: [],
  },
  483585: {
    type: CardType.CreditCard,
    name: "Revolution",
    incentives: [
      {
        name: "cashback",
        type: "percent",
        value: 0.5,
      },
    ],
  },
  451297: {
    type: CardType.CreditCard,
    name: "Visa Platinum",
    incentives: [],
  },
  496645: {
    type: CardType.CreditCard,
    name: "Visa Platinum",
    incentives: [],
  },
  492160: {
    type: CardType.CreditCard,
    name: "Live+",
    incentives: [],
  },
  512043: {
    type: CardType.CreditCard,
    name: "Premier Mastercard",
    incentives: [
      {
        name: "cashback",
        type: "percent",
        value: 0.5,
      },
    ],
  },
  541287: {
    type: CardType.CreditCard,
    name: "MasterCard Classic",
    incentives: [],
  },
  544234: {
    type: CardType.CreditCard,
    name: "MasterCard Gold",
    incentives: [],
  },
  489085: {
    type: CardType.CreditCard,
    name: "Visa Infinite",
    incentives: [
      {
        name: "cashback",
        type: "percent",
        value: 0.5,
      },
    ],
  },
  455228: {
    type: CardType.CreditCardUSD,
    name: "Visa USD Gold",
    incentives: [],
  },
  455227: {
    type: CardType.CreditCardUSD,
    name: "Visa USD Classic",
    incentives: [],
  },
  539700: {
    type: CardType.CreditCardUSD,
    name: "Premier Mastercard USD",
    incentives: [
      {
        name: "cashback",
        type: "percent",
        value: 0.5,
      },
    ],
  },
  436326: {
    type: CardType.DebitCard,
    name: "Advance Visa Debit Card",
    incentives: [],
  },
  436327: {
    type: CardType.DebitCard,
    name: "Advance Visa Debit Ploc",
    incentives: [],
  },
  458555: {
    type: CardType.DebitCard,
    name: "Visa Debit Ploc",
    incentives: [],
  },
  458556: {
    type: CardType.DebitCard,
    name: "Premier Visa Debit Card",
    incentives: [],
  },
  458557: {
    type: CardType.DebitCard,
    name: "Visa Debit Card",
    incentives: [],
  },
  458558: {
    type: CardType.DebitCard,
    name: "Premier Visa Debit Ploc",
    incentives: [],
  },
};
